import { render, staticRenderFns } from "./back-abroadlogistics.vue?vue&type=template&id=73e72c7d"
import script from "./back-abroadlogistics.vue?vue&type=script&lang=ts"
export * from "./back-abroadlogistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports